<!-- Step 2: Sensors, reading types and dates. The selector is hidden (not removed) off this
     step, because it keeps the selection inside itself. -->
<div class="wizard-step wizard-step-fill" [style.display]="step === 2 ? 'flex' : 'none'">
  <div class="step-title">{{ isEditMode ? 'Edit' : 'Create' }} Map Favorite</div>
  <div class="step-subtitle">Select sensors, reading types and dates</div>

  <kig-sensor-reading-selector #selector
      [showReadingSourceOptions]="false"
      (selectionChanged)="onSelectionChanged($event)"
      (refreshRequested)="refreshReadings()">
  </kig-sensor-reading-selector>
</div>

<!-- Step 3: Arrange the map -->
<div *ngIf="step === 3" class="wizard-step">
  <div class="step-title">{{ isEditMode ? 'Edit' : 'Create' }} Map Favorite</div>
  <div class="step-subtitle">Arrange the map</div>

  <div class="hint">
    Arrange the map in the preview the way it should appear on the dashboard:
  </div>
  <ul class="hint" style="margin-top: 6px;">
    <li>Pan and zoom, and switch between map and satellite views.</li>
    <li>Click a pin to open its popup. Drag the popup by its header and pick a reading type to chart it.</li>
    <li>Click <strong>Labels</strong> on the map to add text, arrows, sticky notes and highlighted regions, then drag them into place. Check <strong>Dynamic (sensor value)</strong> to show a live reading.</li>
  </ul>

  <div class="hint" style="margin-top: 10px;">
    {{ m.selectedSensors.length }} sensor(s), {{ m.selectedReadingTypes.length }} reading type(s), {{ m.dateRangeName }}.
  </div>
  <div class="hint" style="margin-top: 4px;">
    {{ m.labels.length }} label(s){{ dynamicLabelCount > 0 ? ', ' + dynamicLabelCount + ' dynamic' : '' }}.
  </div>
</div>

<!-- Step 4: Save -->
<div *ngIf="step === 4" class="wizard-step">
  <div class="step-title">{{ isEditMode ? 'Edit' : 'Create' }} Map Favorite</div>

  <div class="step-subtitle">Save Map Favorite</div>
  <div class="form-group">
    <label>Map Favorite Name</label>
    <input type="text" name="wizardMapFavoriteName" class="form-control" placeholder="Map Favorite" maxlength="256"
           [class.input-error]="favoriteNameTaken"
           [(ngModel)]="m.favoriteName" (ngModelChange)="onSaveFieldChanged()" />
    <div class="error-hint" *ngIf="favoriteNameTaken">A map favorite with this name already exists.</div>
  </div>
  <div class="form-group">
    <label>Access Group</label>
    <ngx-select-dropdown [(ngModel)]="m.favoriteUserGroup" [config]="userGroupConfig"
                         [options]="associatedUserGroups" name="wizardMapFavoriteGroup"></ngx-select-dropdown>
  </div>

  <ng-container *ngIf="!isEditMode">
    <div class="step-subtitle" style="margin-top: 18px;">Create or update dashboard</div>
    <div class="form-group radio-row">
      <label>
        <input type="radio" name="wizardMapDashTarget" value="new"
               [(ngModel)]="m.dashboardTargetMode" (ngModelChange)="onSaveFieldChanged()" /> Add to new dashboard
      </label>
      <label>
        <input type="radio" name="wizardMapDashTarget" value="existing"
               [(ngModel)]="m.dashboardTargetMode" (ngModelChange)="onSaveFieldChanged()" /> Add to existing dashboard
      </label>
    </div>

    <div class="form-group" *ngIf="m.dashboardTargetMode === 'new'">
      <input type="text" name="wizardMapNewDashName" class="form-control" placeholder="New dashboard name"
             [class.input-error]="newDashboardNameTaken"
             [(ngModel)]="m.newDashboardName" (ngModelChange)="onSaveFieldChanged()" />
      <div class="error-hint" *ngIf="newDashboardNameTaken">A dashboard with this name already exists.</div>
    </div>
    <div class="form-group" *ngIf="m.dashboardTargetMode === 'existing'">
      <ng-select [items]="dashboards"
                 bindLabel="name"
                 placeholder="Select Dashboard"
                 [(ngModel)]="m.targetDashboard"
                 (ngModelChange)="onSaveFieldChanged()">
      </ng-select>
    </div>
  </ng-container>

  <div class="hint" *ngIf="isEditMode">Finish will update this map favorite, its map view and its labels.</div>
</div>
